module.exports = __webpack_public_path__ + "static/media/floral-cover.7a33fda5.jpg";